// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U6B-","questions":"styles_questions__tGVtJ","footer":"styles_footer__26lcP"};